export function frentistasInRequest(params = {}) {
  return {
    type: '@frentista/FRENTISTAS_IN_REQUEST',
    payload: { params },
  };
}

export function findFrentista(idfrentista) {
  return {
    type: '@frentista/FIND_FRENTISTA',
    payload: { idfrentista },
  };
}

export function failedRequest() {
  return {
    type: '@frentista/FAILED_REQUEST',
  };
}

export function deleteFrentista(idfrentista, params) {
  return {
    type: '@frentista/DELETE_FRENTISTA',
    payload: { idfrentista, params },
  };
}

export function updateFrentista(frentista, params) {
  return {
    type: '@frentista/UPDATE_FRENTISTA',
    payload: { frentista, params },
  };
}

export function storeFrentista(frentista, params) {
  return {
    type: '@frentista/STORE_FRENTISTA',
    payload: { frentista, params },
  };
}

export function successInRequest(
  frentistas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@frentista/SUCCESS_IN_REQUEST',
    payload: { frentistas, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(frentista) {
  return {
    type: '@frentista/SUCCESS_REQUEST',
    payload: { frentista },
  };
}

export function successRemove(params) {
  return {
    type: '@frentista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@frentista/RECORD_FILTERING',
    payload: { params },
  };
}

export function changePosto(params) {
  return {
    type: '@frentista/CHANGE_POSTO',
    payload: { params },
  };
}


